<p-toolbar>
    <app-header-text-icon (toggleChange)="toggleChange.emit($event)"></app-header-text-icon>
  <div class="p-toolbar-group-end">
    <ng-container *ngIf="displayToggleFeature">
      <app-toggle-feature></app-toggle-feature>
    </ng-container>
    <app-header-menu-logged />
  </div>
</p-toolbar>